import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e029078"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "circle-bar" }
const _hoisted_2 = ["width", "height", "viewPort"]
const _hoisted_3 = ["r", "cx", "cy", "stroke-width", "stroke-dasharray"]
const _hoisted_4 = ["r", "cx", "cy", "stroke-width", "stroke-dasharray", "stroke-dashoffset"]

import { computed, ref } from 'vue';

interface Props {
  /**
   * value 0-1
   */
  value: number
  seconds: number
  /**
   * at px
   */
  size: number
  /**
   * thin of circle (px)
   */
  thin: number
  /**
   * font-size in px
   */
  fontSize: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CircleBar',
  props: {
    value: { default: 0.25 },
    seconds: { default: 125 },
    size: { default: 200 },
    thin: { default: 16 },
    fontSize: { default: 16 }
  },
  setup(__props: any) {

const props = __props as { value: number, seconds: number, size: number, thin: number, fontSize: number };


// const value = ref(0)
const dashArray = computed(() => {
  return Math.PI * props.size
})
const dashOffset = computed(() => {
  return ((1 - props.value)) * dashArray.value
})

const timeFormat = computed(() => {
  return correctLength(Math.floor(props.seconds / 60) )+ ':' + correctLength(Math.round(props.seconds % 60))
})

function correctLength(value: number) {
  return value < 10 ? `0${value}` : value
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", {
      id: "svg",
      width: __props.size,
      height: __props.size,
      viewPort: `0 0 ${__props.size/2} ${__props.size/2}`,
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      _createElementVNode("circle", {
        r: __props.size/2-__props.thin/2,
        cx: `${__props.size/2}`,
        cy: `${__props.size/2}`,
        fill: "transparent",
        "stroke-width": `${__props.thin}px`,
        "stroke-dasharray": _unref(dashArray),
        "stroke-dashoffset": "0"
      }, null, 8, _hoisted_3),
      _createElementVNode("circle", {
        id: "bar",
        r: __props.size/2-__props.thin/2,
        cx: `${__props.size/2}`,
        cy: `${__props.size/2}`,
        fill: "transparent",
        "stroke-width": `${__props.thin}px`,
        "stroke-dasharray": _unref(dashArray),
        "stroke-dashoffset": `${_unref(dashOffset)}px`
      }, null, 8, _hoisted_4)
    ], 8, _hoisted_2)),
    _createElementVNode("div", {
      class: "legend",
      style: _normalizeStyle(`font-size: ${props.fontSize}px`)
    }, _toDisplayString(_unref(timeFormat)), 5)
  ]))
}
}

})